
import { Button } from "react-bootstrap";

import Home from "./componnets/Home";
import SignUp from "./componnets/SignUp";
import SignIn from "./componnets/SignIn";
import {
  Route,
  RouterProvider,
  Routes,
  createBrowserRouter,
  useLocation,
} from "react-router-dom";
import PrivacyPolicy from "./componnets/PrivacyPolicy";
import { useState } from "react";
import ContactUs from "./componnets/ContactUs";
import Withdrewl from "./componnets/Withdrewl";
import NotFound from "./componnets/NotFound";
import Deposit from "./componnets/Deposit";



function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="signin" element={<SignIn />} />
        <Route path="signup" element={<SignUp />} />
        <Route path="home" element={<Home />} />
        <Route path="contactus" element={<ContactUs />} />
        <Route path="withdrewl" element={<Withdrewl />} />
        <Route path="deposit" element={<Deposit />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      

    </>
  );
}

export default App;
